import React, { Component } from 'react';

import { Loading, Alert } from 'Components/Partials';
import { PrimaryButton } from 'Components/Button';
import { FormHandler, Label } from 'Components/Form';
import ReactSelect from 'react-select';
import Authenticated from "Components/Layouts/Authenticated";
import PageHeader from "Components/Utilities/PageHeader";
import SurveyAPI from "Services/Api/Survey/Survey";

class Survey extends Component {
    roles = [
        { value: "No7 Advisor", label: "No7 Advisor" },
        { value: "No7 Business Manager", label: "No7 Business Manager" },
        { value: "Store/General Manager", label: "Store/General Manager" },
        { value: "Area Manager", label: "Area Manager" },
        { value: "Head of Stores", label: "Head of Stores" },
        { value: "No7 Field Team", label: "No7 Field Team" },
        { value: "Support Office", label: "Support Office" },
    ];

    /**
     * @var state
     * @type {{loading: boolean, show: boolean, submission: boolean}}
     */
    state = {
        loading: true,
        submission: false,
        question: 1,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.props.setInitialValues({
            results: [],
        });

        this.fetchSubmission();
    };

    fetchSubmission = async () => {
        const request = await SurveyAPI.checkSubmission();

        if (request.success) {
            this.setState({
                submission: request.data.submission,
                loading: false,
            });
        }
    };

    /**
     * @method success
     */
    success = () => {
        this.setState({
            submission: true,
        });
    };

    /**
     * @method updateResults
     * @param {string} question
     * @param {string} answer
     */
    updateResults = (question, answer) => {
        const { handleInput, form } = this.props;

        let new_results = {};

        if (form.results) {
            new_results = {
                ...form.results,
            }
        }

        new_results[question] = answer;

        handleInput('results', new_results);
    }

    /**
     * @method storeSurvey
     * @param {object} form
     * @return {Promise<*>}
     */
    storeSurvey = (form) => {
        const { setAlert, setWorking, currentSession } = this.props;

        if (!form.results || Object.keys(form.results).length !== 26) {
            setAlert('error', 'You must provide an answer to every question.', []);
            setWorking(false);
            return null;
        }

        let results = Object.entries(form.results).map((result, key) => {
            return {
                question: result[0].toString(),
                answer: result[1].toString(),
            };
        });

        return SurveyAPI.store({
            survey: this.state.survey,
            survey_type: 'test',
            results: results,
        });
    }

    /**
     * @method renderSuccess
     * @return {JSX.Element}
     */
    renderSuccess() {
        return <div className="p-4 md:p-8 text-center py-10 px-5 md:px-10 mb-10 ">
                    <div className="max-w-4xl mx-auto py-10 px-5 md:px-10">
                        <h1 className="text-center text-3xl mx-8 lg:mt-20 mb-12 font-bold uppercase">
                            Thank you for your submission
                        </h1>
                    </div>
                </div>;
    }

    /**
     * @method renderSurvey
     * @return {JSX.Element}
     */
    renderSurvey() {
        const { handleSubmit, resetAlert, working, alert } = this.props;

        const { loading, submission, question } = this.state;

        return <>
                  <h3 className="text-center text-3xl mx-8 lg:mt-20 mb-12 font-bold uppercase">
                      Question {question}
                  </h3>

                    <div
                        className="max-w-4xl mx-auto py-10 px-5 md:px-10 ">
                        {!loading && !submission && (
                            <form onSubmit={(e) => handleSubmit(e, this.storeSurvey, this.success, true)}>
                                {alert && <Alert {...alert} />}

                                {question === 1 &&
                                    <div>
                                        Overall, what would you score the MINI UK Tokyo Incentive?
                                        <br />
                                        {this.renderSurveyScaleA(0)}
                                    </div>
                                }

                                {question === 2 &&
                                    <div>
                                        How would you score the communications leading up to the incentive including the monthly leader boards?
                                        <br />
                                        {this.renderSurveyScaleA(1)}
                                    </div>
                                }

                                {question === 3 &&
                                    <div>
                                        Any other comments on the communications leading up to the event?
                                        <br />
                                        {this.renderTextInput(2)}
                                    </div>
                                }

                                {question === 4 &&
                                    <div>
                                        How would you score the registration process?
                                        <br />
                                        {this.renderSurveyScaleA(3)}
                                    </div>
                                }
                                {question === 5 &&
                                    <div>
                                        Any other comments on the registration process?
                                        <br />
                                        {this.renderTextInput(4)}
                                    </div>
                                }

                                {question === 6 &&
                                    <div>
                                        How would you score Tokyo as a destination?
                                        <br />
                                        {this.renderSurveyScaleA(5)}
                                    </div>
                                }

                                {question === 7 &&
                                    <div>
                                        Any comments about Tokyo as a destination?
                                        <br />
                                        {this.renderTextInput(6)}
                                    </div>
                                }

                                {question === 8 &&
                                    <div>
                                        How would you score the Kimpton Shinjuku hotel?
                                        <br />
                                        {this.renderSurveyScaleA(7)}
                                    </div>
                                }

                                {question === 9 &&
                                    <div>
                                        Any other comments on the Kimpton Shinjuku hotel?
                                        <br />
                                        {this.renderTextInput(8)}
                                    </div>
                                }

                                {question === 10 &&
                                    <div>
                                        How would you score the daytime events / activities / lunches?
                                        <br />
                                        {this.renderSurveyScaleA(9)}
                                    </div>
                                }

                                {question === 11 &&
                                    <div>
                                        What was your favourite daytime event / activity / lunch?
                                        <br />
                                        {this.renderTextInput(10)}
                                    </div>
                                }

                                {question === 12 &&
                                    <div>
                                        Any other comments on the daytime programme?
                                        <br />
                                        {this.renderTextInput(11)}
                                    </div>
                                }

                                {question === 13 &&
                                    <div>
                                        How would you score the evening events / dinners?
                                        <br />
                                        {this.renderSurveyScaleA(12)}
                                    </div>
                                }

                                {question === 14 &&
                                    <div>
                                        What was your favourite evening event / dinner?
                                        <br />
                                        {this.renderTextInput(13)}
                                    </div>
                                }

                                {question === 15 &&
                                    <div>
                                        Any other comments on the evening programme?
                                        <br />
                                        {this.renderTextInput(14)}
                                    </div>
                                }

                                {question === 16 &&
                                    <div>
                                        Please tell us your top highlight/s from the Tokyo Incentive
                                        <br />
                                        {this.renderTextInput(15)}
                                    </div>
                                }

                                {question === 17 &&
                                    <div>
                                        Did you download and use the Event App Vamoos?
                                        <br />
                                        {this.renderSurveyScaleBoolean(16)}
                                    </div>
                                }

                                {question === 18 &&
                                    <div>
                                        How would you rate the Event App?
                                        <br />
                                        {this.renderSurveyScaleA(17)}
                                    </div>
                                }

                                {question === 19 &&
                                    <div>
                                        Any other comments on the Event App?<br />
                                        {this.renderTextInput(18)}
                                    </div>
                                }

                                {question === 20 &&
                                    <div>
                                        How important are international trips like the Tokyo Incentive (1 not at all important, 5 very important) to you?
                                        <br />
                                        {this.renderSurveyScaleNumeric(19)}
                                    </div>
                                }
                                {question === 21 &&
                                    <div>
                                        How important are international trips like the Tokyo Incentive (1 not at all important, 5 very important) to your business?
                                        <br />
                                        {this.renderSurveyScaleNumeric(20)}
                                    </div>
                                }
                                {question === 22 &&
                                    <div>
                                        How important are international trips like the Tokyo Incentive (1 not at all important, 5 very important) to your relationship
                                        with MINI?
                                        <br />
                                        {this.renderSurveyScaleNumeric(21)}
                                    </div>
                                }
                                {question === 23 &&
                                    <div>
                                        Any other comments on the Tokyo Incentive and its importance?
                                        <br />
                                        {this.renderTextInput(22)}
                                    </div>
                                }
                                {question === 24 &&
                                    <div>
                                        How would you rate the Events team support in the run up to the event and whilst onsite?
                                        <br />
                                        {this.renderSurveyScaleA(23)}
                                    </div>
                                }
                                {question === 25 &&
                                    <div>
                                        Any comments on the Events team support?
                                        <br />
                                        {this.renderTextInput(24)}
                                    </div>
                                }
                                {question === 26 &&
                                    <div>
                                        Finally, please tell us what we could have done better or any ideas you have to help improve future incentives?
                                        <br />
                                        {this.renderTextInput(25)}
                                    </div>
                                }


                                <div className={`mt-4 flex ${question === 1 ? 'justify-end' : 'justify-between'}`}>
                                    {question !== 1 && (
                                        <PrimaryButton
                                            working={working}
                                            onClick={() => {
                                                resetAlert();
                                                this.setState({ question: +question - 1 });
                                            }}
                                            text="Previous"
                                        />
                                    )}

                                    {question !== 26 && (
                                        <PrimaryButton
                                            working={working}
                                            onClick={() => {
                                                resetAlert();
                                                if (this.props.form.results[question - 1] && this.props.form.results[question - 1] !== '') {
                                                    this.setState({ question: +question + 1 });
                                                }
                                            }}
                                            type="button"
                                            text="Next"
                                        />
                                    )}

                                    {question === 26 &&
                                        <PrimaryButton
                                            working={working}
                                            text="Submit"
                                        />
                                    }
                                </div>
                            </form>
                        )}
                    </div>
                </>;
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { handleSubmit, resetAlert, working, alert } = this.props;

        const { loading, submission, question } = this.state;

        return (
            <Authenticated>
                <PageHeader
                    imgSrc="headers/survey.png"
                    additionalClasses={"border-b-12 border-app-yellow"}
                />

                { working && <Loading/> }

                { !working && submission &&
                    (this.renderSuccess())
                }

                { !working && !submission &&
                    (this.renderSurvey())
                }
            </Authenticated>
        );
    }

    /**
     * @method renderSurveyScaleA
     * @param {string} question
     * @return {JSX.Element}
     */
    renderSurveyScaleA = (question) => {
        return (
            <div className="m-8 p-3 w-max mx-auto flex flex-col md:flex-row gap-12">
                {this.renderRadioButton(question, 5, 'excellent')}
                {this.renderRadioButton(question, 4, 'very good')}
                {this.renderRadioButton(question, 3, 'good')}
                {this.renderRadioButton(question, 2, 'not very good')}
                {this.renderRadioButton(question, 1, 'poor')}
            </div>
        );
    }

    /**
     * @method renderSurveyScaleB
     * @param {string} question
     * @return {JSX.Element}
     */
    renderSurveyScaleB = (question) => {
        return (
            <div className="m-8 p-3 w-max mx-auto flex flex-col md:flex-row gap-12">
                {this.renderRadioButton(question, 5, 'strongly agree')}
                {this.renderRadioButton(question, 4, 'agree')}
                {this.renderRadioButton(question, 3, 'neutral')}
                {this.renderRadioButton(question, 2, 'disagree')}
                {this.renderRadioButton(question, 1, 'strongly disagree')}
            </div>
        );
    }

    /**
     * @method renderSurveyScaleNumeric
     * @param {string} question
     * @return {JSX.Element}
     */
    renderSurveyScaleNumeric = (question) => {
        return (
            <div className="m-8 p-3 w-max mx-auto flex flex-col md:flex-row gap-12">
                {this.renderRadioButton(question, 1, 1)}
                {this.renderRadioButton(question, 2, 2)}
                {this.renderRadioButton(question, 3, 3)}
                {this.renderRadioButton(question, 4, 4)}
                {this.renderRadioButton(question, 5, 5)}
{/*                {this.renderRadioButton(question, 6, 6)}
                {this.renderRadioButton(question, 7, 7)}
                {this.renderRadioButton(question, 8, 8)}
                {this.renderRadioButton(question, 9, 9)}
                {this.renderRadioButton(question, 10, 10)}*/}
            </div>
        );
    }

    /**
     * @method renderSurveyScaleBoolean
     * @param {string} question
     * @return {JSX.Element}
     */
    renderSurveyScaleBoolean = (question) => {
        return (
            <div className="m-8 p-3 w-max mx-auto flex flex-col md:flex-row gap-12">
                {this.renderRadioButton(question, 'Yes', 'Yes')}
                {this.renderRadioButton(question, 'No', 'No')}
            </div>
        );
    }

    /**
     * @method renderRadioButton
     * @param {string} question
     * @param {string} answer
     * @param {string} label
     * @return {JSX.Element}
     */
    renderRadioButton = (question, answer, label) => {
        const { form } = this.props;

        let checked = form.results && form.results[question] ? (form.results[question] === answer) : false;

        return (
            <div className={'flex flex-col items-center w-max w-full gap-2 mx-auto'}>
                <input
                    type="checkbox"
                    id={question + '-' + answer}
                    checked={checked}
                    onChange={() => this.updateResults(question, answer)}

                    className={`
                        h-5 w-5 text-indigo-600 transition duration-150 ease-in-out rounded-lg
                        border hover:border-gray-600 focus:ring-0 focus:outline-none  focus:ring-offset-0 mx-auto cursor-pointer
                        ${checked ? 'bg-app-yellow focus:ring-0 border-app-yellow text-black' : 'border-gray-500'}
                    `}
                    radioGroup={label}
                />

                <Label label={label} htmlFor={question + '-' + answer} className="mb-0 text-center capitalize text-md" />
            </div>
        )
    }

    /**
     * @method renderSelectBar
     * @param {string} question
     * @param {string} options
     * @return {JSX.Element}
     */
    renderSelectBar = (question, options) => {
        const { form } = this.props;

        let selectedValue = form.results && form.results[question] ? form.results[question] : null;

        return (
            <div className="my-2">
                <ReactSelect
                    value={selectedValue ? options.filter(n => n.value === selectedValue)[0] : null}
                    options={options}
                    onChange={(option) => this.updateResults(question, option.value)}
                    isSearchable={false}
                />
            </div>
        );
    }

    /**
     * @method renderTextInput
     * @param {string} question
     * @return {JSX.Element}
     */
    renderTextInput = (question) => {
        const { form } = this.props;

        let value = form.results && form.results[question] ? form.results[question] : null;

        return (
            <input
                type="text"
                value={value ?? ''}
                onChange={(e) => this.updateResults(question, e.target.value)}
                className="bg-white border-b border-black text-black adobe-reg w-full my-8"
            />
        );
    }
};

export default FormHandler(Survey);
